export default "__VITE_ASSET__ae63fb24__"